var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.path === '/')?_c('login-header'):_c('default-header'),_c('router-view'),_c('default-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }